import { CREATE_CHAUFFEUR_V3, CREATE_CHAUFFEUR_V3_SUCCESS, CREATE_CHAUFFEUR_V3_ERROR, CREATE_CHAUFFEUR_V3_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateChauffeurV3 = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHAUFFEUR_V3:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_CHAUFFEUR_V3_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_CHAUFFEUR_V3_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_CHAUFFEUR_V3_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateChauffeurV3;
